import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { usePWA } from "../context/PWAContext";
import { Button, UnifiedCard, UnifiedCardContent } from "./UI";

const PWAInstallGuide = () => {
    const { showInstallGuide, setShowInstallGuide, isIOS } = usePWA();

    if (!showInstallGuide) return null;

    return (
        <AnimatePresence>
            <div className="fixed inset-0 z-[1000] flex items-end sm:items-center justify-center p-4 bg-black/60 backdrop-blur-sm">
                <motion.div
                    initial={{ y: "100%", opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    exit={{ y: "100%", opacity: 0 }}
                    className="w-full max-w-[420px]"
                >
                    <UnifiedCard className="rounded-t-[32px] sm:rounded-[32px] shadow-2xl bg-[var(--color-bg-primary)] overflow-hidden">
                        <div className="p-4 flex justify-center">
                            <div className="w-12 h-1.5 bg-[var(--color-border)] rounded-full sm:hidden" />
                        </div>

                        <UnifiedCardContent className="px-6 pb-8 pt-2">
                            <div className="text-center mb-8">
                                <div className="text-4xl mb-4">📱</div>
                                <h2 className="text-2xl font-black text-[var(--color-text-primary)] mb-2">
                                    Установка приложения
                                </h2>
                                <p className="text-[var(--color-text-secondary)]">
                                    Установите наше приложение на главный экран для быстрого доступа.
                                </p>
                            </div>

                            {isIOS ? (
                                <div className="space-y-6">
                                    <div className="flex items-start gap-4">
                                        <div className="w-10 h-10 rounded-full bg-[var(--color-primary)]/10 text-[var(--color-primary)] flex items-center justify-center font-black shrink-0">
                                            1
                                        </div>
                                        <div>
                                            <p className="font-bold text-[var(--color-text-primary)]">Нажмите «Поделиться»</p>
                                            <p className="text-sm text-[var(--color-text-tertiary)]">
                                                Нажмите на иконку меню «Поделиться» (квадрат со стрелкой вверх) в нижней панели Safari.
                                            </p>
                                        </div>
                                    </div>

                                    <div className="flex items-start gap-4">
                                        <div className="w-10 h-10 rounded-full bg-[var(--color-primary)]/10 text-[var(--color-primary)] flex items-center justify-center font-black shrink-0">
                                            2
                                        </div>
                                        <div>
                                            <p className="font-bold text-[var(--color-text-primary)]">На экран «Домой»</p>
                                            <p className="text-sm text-[var(--color-text-tertiary)]">
                                                Прокрутите список действий вниз и выберите этот пункт в меню.
                                            </p>
                                        </div>
                                    </div>

                                    <div className="flex items-start gap-4">
                                        <div className="w-10 h-10 rounded-full bg-[var(--color-primary)]/10 text-[var(--color-primary)] flex items-center justify-center font-black shrink-0">
                                            3
                                        </div>
                                        <div>
                                            <p className="font-bold text-[var(--color-text-primary)]">Нажмите «Добавить»</p>
                                            <p className="text-sm text-[var(--color-text-tertiary)]">
                                                Подтвердите установку в верхнем правом углу экрана. Готово!
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <div className="text-center p-6 bg-[var(--color-bg-tertiary)] rounded-2xl border border-[var(--color-border-light)]">
                                    <p className="font-bold text-[var(--color-text-primary)] mb-2">Следуйте подсказке браузера</p>
                                    <p className="text-sm text-[var(--color-text-secondary)]">
                                        Если вы не видите системное окно установки, попробуйте найти пункт «Установить приложение» в меню вашего браузера.
                                    </p>
                                </div>
                            )}

                            <div className="mt-10">
                                <Button
                                    variant="primary"
                                    fullWidth
                                    className="rounded-2xl py-4 font-bold !bg-[var(--gradient-primary)]"
                                    onClick={() => setShowInstallGuide(false)}
                                >
                                    Понятно
                                </Button>
                            </div>
                        </UnifiedCardContent>
                    </UnifiedCard>
                </motion.div>
            </div>
        </AnimatePresence>
    );
};

export default PWAInstallGuide;
